module.exports = __webpack_public_path__ + "static/media/bbc_sport_live_olympics_36772906_plot.d5fee402.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_sport_live_olympics_36772906_plot.png
// module id = 364
// module chunks = 0